import classNames from 'classnames';
import React from 'react';
import "./index.less";
var SpecialText = function SpecialText(props) {
  var minus = props.minus,
    style = props.style,
    controlMode = props.controlMode,
    unit = props.unit,
    unitClassName = props.unitClassName,
    unitStyle = props.unitStyle,
    className = props.className,
    price = props.price,
    priceStyle = props.priceStyle,
    priceClassName = props.priceClassName,
    decimalStyle = props.decimalStyle,
    decimalClassName = props.decimalClassName,
    locales = props.locales,
    options = props.options,
    pricePeriod = props.pricePeriod,
    limit = props.limit,
    size = props.size;

  //获取外层元素的classname
  var getOutEleClass = function getOutEleClass() {
    var defaultClass = 'iron-specialText';
    if (size) {
      defaultClass = classNames(defaultClass, "iron-specialText-".concat(size));
    }
    if (className) {
      defaultClass = classNames(defaultClass, className);
    }
    return defaultClass;
  };

  //单位
  var getPricePeriod = function getPricePeriod() {
    var val = null;
    var slash = '/';
    if (pricePeriod !== undefined) {
      val = slash + pricePeriod;
    }
    return val;
  };

  /**
   * 格式化货币
   * @param {number} val 需要格式化的值
   * @param {string} options 货币格式
   * @param {string} locales 地区
   * @example formatCurrency(123.02, "zh-HK", "HKD") => HK$ 123.02
   * 参考[MDN](https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat#%E6%9E%84%E9%80%A0%E5%87%BD%E6%95%B0)
   */
  var formatCurrency = function formatCurrency(val, locales, options) {
    var result = new Intl.NumberFormat(locales, options).format(val);
    return /*#__PURE__*/React.createElement("span", {
      style: priceStyle,
      className: priceClassName
    }, result);
  };

  // 处理数字 保留小数点后两位
  var customRound = function customRound(num, decimalPlaces) {
    var multiplier = Math.pow(10, decimalPlaces);
    var roundedNum = Math.round(num * multiplier) / multiplier;
    return roundedNum;
  };

  //加千分位
  var formatVal = function formatVal(num) {
    return num.toLocaleString();
  };

  //处理金额的显示
  var seperateNum = function seperateNum(price) {
    var priceVal = formatVal(customRound(price, 2));
    //单独对小数点后的金额加样式
    if (decimalClassName || decimalStyle) {
      var priceArr = String(priceVal).split('.');
      var decimalPoint = '';
      if (priceArr.length > 1) {
        var _priceArr$;
        if (((_priceArr$ = priceArr[1]) === null || _priceArr$ === void 0 ? void 0 : _priceArr$.length) === 1) {
          //传入的时候 第二位小数是0 传进来之后0被吞了  这里补上
          priceArr[1] = priceArr[1] + '0';
        }
        decimalPoint = priceArr[1];
      } else {
        decimalPoint = '00';
      }
      //TODO 下面这句表示补00
      // else {
      //   decimalPoint = '00';
      // }
      return /*#__PURE__*/React.createElement(React.Fragment, null, decimalPoint === '' ? priceVal : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, " ", priceArr[0]), /*#__PURE__*/React.createElement("span", {
        className: decimalClassName,
        style: decimalStyle
      }, ".", decimalPoint)));
    } else {
      //直接显示金额
      return priceVal;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: getOutEleClass(),
    style: style
  }, minus, /*#__PURE__*/React.createElement("span", {
    className: "iron-specialText-limit"
  }, limit), controlMode ? formatCurrency(price, locales, options) : /*#__PURE__*/React.createElement(React.Fragment, null, unit && /*#__PURE__*/React.createElement("span", {
    className: unitClassName,
    style: unitStyle
  }, unit), /*#__PURE__*/React.createElement("span", {
    style: priceStyle,
    className: priceClassName
  }, seperateNum(price))), /*#__PURE__*/React.createElement("span", {
    className: "iron-specialText-price-unit"
  }, getPricePeriod()));
};

//處理默認值
SpecialText.defaultProps = {
  size: 'xs',
  price: 0,
  locales: 'zh-HK',
  //默认用粤语地区格式
  options: {
    //默认用粤语地区格式
    style: 'currency',
    currency: 'HKD'
  },
  controlMode: true //默认用mdn中推荐的方式格式化金额
};
export default SpecialText;